import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage         = lazy(() => import('../pages/home/page'));
const MerchandisePage  = lazy(() => import('../pages/merchandise/page'));
const MusicPage        = lazy(() => import('../pages/music/page'));
const NewArrivalsPage  = lazy(() => import('../pages/new-arrivals/page'));
const KidsPage         = lazy(() => import('../pages/kids/page'));
const AdminLoginPage   = lazy(() => import('../pages/admin/LoginPage'));
const AdminDashboard   = lazy(() => import('../pages/admin/DashboardPage'));
const CustomerLogin    = lazy(() => import('../pages/customer/LoginPage'));
const AccountPage      = lazy(() => import('../pages/customer/AccountPage'));

const routes: RouteObject[] = [
  { path: '/',                element: <HomePage /> },
  { path: '/merchandise',     element: <MerchandisePage /> },
  { path: '/music',           element: <MusicPage /> },
  { path: '/new-arrivals',    element: <NewArrivalsPage /> },
  { path: '/kids',            element: <KidsPage /> },
  { path: '/admin',           element: <AdminLoginPage /> },
  { path: '/admin/dashboard', element: <AdminDashboard /> },
  { path: '/login',           element: <CustomerLogin /> },
  { path: '/account',         element: <AccountPage /> },
  { path: '*',                element: <NotFound /> },
];

export default routes;
